import {
    CustomDateType,
    PresetDateType,
    ScheduleSendItemsType,
} from "domains/message-component/components/Compose/components/ScheduleSend/types/ScheduleSend.types";

export const isPresetDateType = (
    value: string | null | undefined,
): value is PresetDateType =>
    !!value &&
    ["todayMorning", "todayEvening", "nextWorkingDay"].includes(value);

export const isCustomDateType = (
    value: string | null | undefined,
): value is CustomDateType => !!value && ["calendar", "frame"].includes(value);

export const mapSendAtTypeToScheduleSendItemsType = (
    sendAtType: string | null | undefined,
): ScheduleSendItemsType => {
    if (isCustomDateType(sendAtType)) return "custom";
    if (isPresetDateType(sendAtType)) return sendAtType;
    return "now";
};
